export type InvestmentDownturnReactionSelectionState = {
  sell: boolean;
  hold: boolean;
  buy: boolean;
};

export type InvestmentDownturnReactionSelectionAction = {
  type: InvestmentDownturnReactionSelectionType;
};

export enum InvestmentDownturnReactionSelectionType {
  Sell = "sell",
  Hold = "hold",
  Buy = "buy",
}
